import { arrayToObj } from '@/utils/utils'
import i18n from '@/locales'

export const PERIOD_TYPES = [
  { key: 'day', value: i18n.t('bill.budget_period_type_day') },
  { key: 'month', value: i18n.t('bill.budget_period_type_month') },
  // { key: 'quarter', value: i18n.t('bill.budget_period_type_quarter') },
  { key: 'year', value: i18n.t('bill.budget_period_type_year') },
]
export const PERIOD_TYPES_MAP = arrayToObj(PERIOD_TYPES, 'key')

export const STATUS = [
  { key: 'ready', value: i18n.t('bill.budget_status_ready') },
  { key: 'running', value: i18n.t('bill.budget_status_running') },
  { key: 'expired', value: i18n.t('bill.budget_status_expired') },
]
export const STATUS_MAP = arrayToObj(STATUS, 'key')

export const ALERT_TYPES = [
  { key: 'cost', value: i18n.t('bill.budget_alert_type_cost') },
]

export const ALERT_THRESHOLD_TYPES = [
  { key: 'amount', value: i18n.t('bill.budget_alert_threshold_type_amount') },
  { key: 'percent', value: i18n.t('bill.budget_alert_threshold_type_percent') },
]

export const SENDING_FREQUENCYS = [
  { key: '5m', value: i18n.t('bill.budget_minute', [5]) },
  { key: '30m', value: i18n.t('bill.budget_minute', [30]) },
  { key: '1h', value: i18n.t('bill.budget_hour', [1]) },
  { key: '3h', value: i18n.t('bill.budget_hour', [3]) },
  { key: '6h', value: i18n.t('bill.budget_hour', [6]) },
  { key: '12h', value: i18n.t('bill.budget_hour', [12]) },
  { key: '1d', value: i18n.t('bill.budget_hour', [24]) },
]

export const TAGS_MATCH_TYPES = [
  { key: false, value: i18n.t('bill.text_284') },
  { key: true, value: i18n.t('bill.text_283') },
]

export const TAGS_MATCH_TYPES_Map = arrayToObj(TAGS_MATCH_TYPES, 'key')
